import { createFileRoute } from '@tanstack/react-router';

import { ReceiptsList } from '../components/ar/ReceiptsList';
import { PageHead } from '../components/layout';
import { useActiveCompanyId, useArReceipts } from '../lib/queries';

export const Route = createFileRoute('/ar/receipts')({ component: ArReceiptsPage });

export function ArReceiptsPage() {
  const companyId = useActiveCompanyId();
  const { data, isPending, error } = useArReceipts(companyId);

  return (
    <div className="page">
      <PageHead crumbs={['ลูกหนี้การค้า', 'ใบรับชำระ']} title="ใบรับชำระ (Receipt Vouchers)" />
      {isPending && (
        <div className="muted" style={{ padding: 24, textAlign: 'center' }}>
          กำลังโหลด…
        </div>
      )}
      {error && (
        <div className="neg" style={{ padding: 24, textAlign: 'center' }}>
          โหลดไม่สำเร็จ: {error.message}
        </div>
      )}
      {data && <ReceiptsList receipts={data} />}
    </div>
  );
}
